import { render, staticRenderFns } from "./boxZybmbj.vue?vue&type=template&id=566f0c61&scoped=true"
import script from "./boxZybmbj.vue?vue&type=script&lang=js"
export * from "./boxZybmbj.vue?vue&type=script&lang=js"
import style0 from "./boxZybmbj.vue?vue&type=style&index=0&id=566f0c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f0c61",
  null
  
)

export default component.exports